import React from 'react'
import { Container, Row, Col, Image, Card, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router";
import MobileApproachCarousel from './MobileApproachCarousel';
import TechBlock from '../TechBlock';
import MobileApplicationFaq from './MobileApplicationFaq';
import ServiceSlider from './ServiceSlider';

import gradient from "../../Assets/banner-blue-pill.png";

export default function Contact() {
    return (
        <>
            <section className='bg-theme section-hero'>
                <Container className="header-section pb-5 pt-2">
                    <Breadcrumb className="custom-breadcrumb">
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item href="/service">
                            Services
                        </Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item active>Mobile Application Development</Breadcrumb.Item>
                    </Breadcrumb>
                    <Row className='mb-4 pt-5'>
                        <Col md={11}>
                            <h2 className="heading-style-h2 pb-3 text-white"><span className="text-gradient-1">Mobile Application Development </span>Services</h2>
                            <h5 className='heading-style-h5 pb-5 text-white'>Applications that feel intuitive to use and stay consistent in how they perform across devices and platforms.</h5>
                        </Col>
                    </Row>
                    <div className="pills-wrap">

                        <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                            <Image src={gradient} />
                        </div>
                    </div>
                </Container >
            </section >
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row>
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">What <span className="text-gradient-1">Mobile App Development</span><br />Looks Like in Practice</h2>
                        </Col>
                        <h5 className='heading-style-h5 mb-5'>Mobile applications are often where users interact with your business the most. They need to be easy to use, responsive, and reliable across devices.</h5>
                        <h5 className='heading-style-h5 mb-5'>Mobile app development involves creating applications that support how users actually interact with your product, whether it’s internal tools, customer-facing apps or platforms used at scale.</h5>
                        <h5 className='heading-style-h5'>At Parabola IT, the focus is on keeping apps practical and consistent. That means balancing usability, performance, and maintainability, so the app continues to function reliably as usage increases.</h5>
                    </Row>
                </Container>
            </section>
            <Container className="padding-section-large">
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We Offer in <span className="text-gradient-1">Mobile App Development</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A set of capabilities covering development, integration, and ongoing improvement of mobile applications.</h5>
                    </Col>
                </Row>
                <Row className="align-items-center mb-5 serviceCard bg-gradient-1 p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>

                        <div className="banner-content">
                            <h4 className='heading-style-h4'>iOS and Android App Development</h4>
                            <p className="desc">We develop mobile applications for both iOS and Android, focusing on usability, responsiveness, and platform-specific behavior.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Native application development</span>
                                <span>Platform-specific optimization</span>
                                <span>Device and OS compatibility testing</span>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Cross-Platform Application Development</h4>
                            <p className="desc">For faster development and easier maintenance, we build applications that work across platforms using a shared codebase.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Flutter and React Native development</span>
                                <span>Shared architecture across platforms</span>
                                <span>Faster updates and release cycles</span>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Performance-Focused Builds</h4>
                            <p className="desc">Mobile applications need to remain responsive and stable as usage increases. We focus on performance from the start.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Performance tuning and optimization</span>
                                <span>Load handling and responsiveness</span>
                                <span>Stability improvements across app usage</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={10}>
                            <h2 className='heading-style-h2 pb-3'>Let’s Talk Through the Right Mobile Approach </h2>
                            <p>From platform choice to rollout, we can help you shape the next step with more clarity.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={2} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Let's Talk</Link>
                        </Col>

                    </Row>
                </Container>
            </section>
            <MobileApproachCarousel />
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row className=''>
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">How Mobile Apps Support<br /><span className="text-gradient-1">Your Business</span></h2>
                            <h5 className='heading-style-h5 pb-5'>Practical ways mobile applications improve access, usage and day-to-day interactions with your product.</h5>
                        </Col>
                    </Row>
                    <Row className="d-flex align-items-stretch stagger-wrapper">
                        <div className="stagger-grid">
                            {/* Card 1 */}
                            <div className="card-box primary-border light-bg logo-bg">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Faster access to your product or service</h5>
                                <p>Mobile apps give users a direct way to interact with your platform without relying on multiple steps or browser-based flows.</p>
                            </div>

                            {/* Card 2 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Supports transactions and in-app purchases</h5>
                                <p>Enable users to complete purchases, subscriptions or actions directly within the app environment.</p>
                            </div>

                            {/* Card 3 */}
                            <div className="card-box card-2">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>More consistent user engagement</h5>
                                <p>With notifications and regular usage patterns, apps help users stay connected and interact more frequently.</p>
                            </div>

                            {/* Card 4 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Better visibility into user behavior</h5>
                                <p>Track how users interact with your app, from actions to usage patterns, helping you understand what works and what needs improvement.</p>
                            </div>

                            {/* Card 5 */}
                            <div className="card-box card-4">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Easier updates and ongoing improvements</h5>
                                <p>Roll out updates, fix issues, and introduce new features without disrupting the overall experience.</p>
                            </div>

                        </div>
                    </Row>

                </Container>
            </section>
            <TechBlock />
            <ServiceSlider />
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={9}>
                            <h2 className='heading-style-h2 pb-3'>Let’s Shape the Right Mobile Experience</h2>
                            <p>We help turn product ideas into mobile applications that are easier to use, manage, and evolve over time.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={3} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Talk to Our Team</Link>
                        </Col>
                    </Row>
                </Container>
            </section>
            <MobileApplicationFaq />
        </>
    )
}
